define('formatSmsLink',[], function () {

    var iOsVersion = (function () {
        if (Modernizr.ios) {
            // Regex taken from https://stackoverflow.com/questions/11171895/detecting-ios-version-number-from-user-agent-using-regular-expressions
            var version = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            return [
                parseInt(version[1], 10),
                parseInt(version[2], 10),
                parseInt(version[3] || 0, 10)
            ];
        }
    })();

    var separator = (function () {
        var defaultSeparator = '%2F&';
        var androidSeparator = '?';

        if (Modernizr.android) {
            return androidSeparator;
        }

        if (Modernizr.ios && iOsVersion) {
            return iOsVersion[0] < 8 ? ';' : '&';
        }

        return defaultSeparator;
    })();

    /**
     *  Generate a SMS protocol link according to mobile OS
     *  See https://github.com/mobyinc/sms-link/blob/master/index.js
     */
    return function (options) {
        if (!options.phone && !options.body) {
            return;
        }
        var phone = options.phone || '';
        var body = encodeURIComponent(options.body || '');
        return 'sms:' + phone + (body ? separator + 'body=' + body : '');
    };

});
